export default __webpack_public_path__ + "static/media/Head_3_Ear_2_C1.c0eb509b.svg";